import { ApiGetKeys, ApiPostKeys } from './apis';

/**
 * post 请求依赖，如果一个post依赖了某个get请求，那么请求成功后会刷新相关依赖的数据
 * 比如 get 为一个列表数据，post为添加一条列表数据，这时候post成功后会自动重新拉取get获得最新的数据
 */
export default {
  // 'getAllMarketTypeList': ['']
} as Partial<Record<ApiGetKeys, ApiPostKeys[]>>;
